// @ts-ignore
import VueWorker from 'vue-worker';
import Vue from 'vue';

Vue.use(VueWorker);
